import React from 'react';

const PortfolioModal = ({ project, show, onHide }) => {
  if (!project) return null;

  return (
    <div className={`modal fade ${show ? 'show' : ''}`} id={`portfolioModal-${project.id}`} tabIndex="-1" role="dialog" aria-labelledby="portfolioModalLabel" aria-hidden={!show} style={{ display: show ? 'block' : 'none' }}>
      <div className="modal-dialog modal-lg">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="portfolioModalLabel">{project.title}</h5>
            <button type="button" className="close" data-dismiss="modal" aria-label="Close" onClick={onHide}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <img src={project.image} className="img-fluid" alt={project.title} />
            <div className="mb-4">
              <span className="badge badge-info mr-2">{project.category}</span>
              <span className="text-muted">{project.date}</span>
            </div>
            <p>{project.description}</p>
            <h6 className="mt-4">使用技術：</h6>
            <div className="mb-4">
              {project.technologies.map((tech, index) => (
                <span key={index} className="badge badge-secondary mr-2 mb-2">{tech}</span>
              ))}
            </div>
            <h6>客戶：</h6>
            <p>{project.client}</p>
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onHide}>關閉</button>
          </div>
        </div>
      </div>
      {show && <div className="modal-backdrop fade show" onClick={onHide}></div>}
    </div>
  );
};

export default PortfolioModal; 